module.exports = __webpack_public_path__ + "static/media/42.51ef67f4.JPG";